<template>
  <div>
    <a-modal v-model="visible" width="720px" :title="navigationId ? '修改导航' : '添加导航'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="Logo" prop="logo">
          <a-upload name="resource" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :headers="headers" :action="actionUrl" @change="handleChange">
            <div v-if="modalForm.logo">
              <a-avatar shape="square" :size="64" :src="modalForm.logo" />
            </div>
            <div v-else>
              <a-icon :type="uplaadLoading ? 'loading' : 'plus'" />
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="名称" prop="title">
          <a-input v-model="modalForm.title" />
        </a-form-model-item>
        <a-form-model-item label="链接" prop="url">
          <a-textarea v-model="modalForm.url" placeholder="链接地址" :auto-size="{ minRows: 2, maxRows: 3 }" />
        </a-form-model-item>
        <a-form-model-item label="分类" prop="category_id">
          <a-select v-model="modalForm.category_id" style="width: 100%">
            <a-select-option v-for="category in categoryItems" :key="category.id" :value="category.id"> {{ category.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-textarea v-model="modalForm.description" placeholder="导航描述" :auto-size="{ minRows: 3, maxRows: 3 }" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="modalForm.sort" style="width: 100%" :min="1" :max="100000" :default-value="1" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { navigationAdd, navigationModify, navigationCategoryList } from '@/api/system/navigation';
import { getCookies } from '@/utils/utils';

export default {
  name: 'TeamModal',
  props: {
    navigationId: {
      type: [Number, String],
      default: null
    },
    navigationData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      categoryItems: [],
      uplaadLoading: false,
      uploadData: {},
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      visible: this.isShow,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      modalForm: {
        logo: null
      },
      rules: {
        logo: [{ required: true, message: 'Logo不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        url: [{ required: true, message: '链接地址不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '描述不能为空', trigger: 'blur' }],
        category_id: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getCategoryList();
        if (this.navigationId) {
          this.modalForm = {
            ...this.navigationData
          };
        } else {
          this.modalForm = {
            name: null,
            sort: 1
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.$emit('close', 'submit');
    },

    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uplaadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uplaadLoading = false;
        const { code, message, data } = info.file.response;
        if (code === 2000) {
          this.modalForm.logo = data.resource_url;
        } else {
          this.$message.warning(message);
        }
      }
    },

    getCategoryList() {
      navigationCategoryList({}).then(res => {
        this.categoryItems = res.data.items;
      });
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.navigationId) {
            this.loading = true;
            navigationModify({ id: this.navigationId, ...this.modalForm })
              .then(() => {
                this.loading = false;
                this.$message.success('导航修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            navigationAdd(this.modalForm)
              .then(() => {
                this.loading = false;
                this.$message.success('导航添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
